module.exports = __webpack_public_path__ + "img/redmond.366f6c65.png";